import { render, staticRenderFns } from "./pay_error.vue?vue&type=template&id=8f7ef26c&"
import script from "./pay_error.vue?vue&type=script&lang=js&"
export * from "./pay_error.vue?vue&type=script&lang=js&"
import style0 from "./pay_error.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports